var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.773 144.773",
    style: {
      enableBackground: "new 0 0 144.773 144.773"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5C002"
    },
    width: 145,
    height: 145,
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 145,
    height: 145,
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M107.053,116.94c-4.666-8.833-34.666-14.376-34.666-14.376s-30,5.543-34.666,14.376 c-3.449,12.258-6.334,27.833-6.334,27.833h41h41C113.387,144.773,111.438,128.073,107.053,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.387,102.564c0,0,30,5.543,34.666,14.376c4.386,11.133,6.334,27.833,6.334,27.833h-41V102.564 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.22,
    y: 84.606,
    style: {
      fill: "#F1C9A5"
    },
    width: 16.334,
    height: 27.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.387,
    y: 84.606,
    style: {
      fill: "#E4B692"
    },
    width: 8.167,
    height: 27.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C"
    },
    d: "M64.22,97.273c1.469,4.217,7.397,6.634,11.751,6.634 c1.575,0,3.107-0.264,4.583-0.747V84.606H64.22V97.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783c-11.598,0-21,9.709-21,26.783 c0,22.966,9.402,30.917,21,30.917C83.984,98.274,93.387,89.366,93.387,67.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M90.19,79.197c-3.807-0.398-6.377-4.5-5.732-9.156c0.637-4.66,4.242-8.12,8.051-7.724 c3.805,0.396,6.371,4.496,5.729,9.156C97.599,76.134,93.997,79.591,90.19,79.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M46.685,71.474c-0.643-4.66,1.924-8.76,5.727-9.156c3.81-0.396,7.416,3.063,8.055,7.724 c0.643,4.656-1.93,8.758-5.734,9.156C50.925,79.591,47.323,76.134,46.685,71.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783v57.7C83.984,98.274,93.387,89.366,93.387,67.357 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030"
    },
    d: "M91.277,81.668c-1.13,3.176-3.041,6.994-6.494,6.994c-4.316,0-7.403-3.508-12.354-3.508 c-0.014,0-0.027,0.002-0.041,0.002c-0.015,0-0.028-0.002-0.043-0.002c-4.95,0-8.036,3.508-12.354,3.508 c-3.453,0-5.363-3.818-6.493-6.994L52.52,75.55v7.321c0,0,1.641,8.622,4.79,10.705c2.565,2.279,10.938,6.183,15.033,6.183h0.001 c0.014,0,0.028-0.002,0.043-0.002c0.014,0,0.028,0.002,0.041,0.002h0.002c4.096,0,12.469-3.903,15.033-6.183 c3.149-2.083,4.79-10.705,4.79-10.705V75.55L91.277,81.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030"
    },
    d: "M62.218,43.841c0,0,3.9,15.787,25.632,23.773c-2.044-3.529-2.415-7.801-2.415-7.801 s3.529,3.715,9.286,6.687c3.158-6.314,6.873-15.787-1.485-20.987C84.878,40.312,65.004,31.024,62.218,43.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030"
    },
    d: "M54.975,66.314c0,0,1.613-18.023,8.328-22.01c-5.728-2.499-14.457,5.108-13.529,9.751 C50.703,58.699,54.975,66.314,54.975,66.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB621E"
    },
    d: "M107.053,116.94c-2.726-5.158-14.082-9.191-23.065-11.656c-0.352,6.11-5.402,10.96-11.601,10.96 c-6.198,0-11.249-4.85-11.6-10.96c-8.983,2.465-20.34,6.498-23.066,11.656c-3.449,12.258-6.334,27.833-6.334,27.833h41h41 C113.387,144.773,111.438,128.073,107.053,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#E53D0C"
    },
    d: "M60.114,108.284c0.372,6.11,5.715,10.96,12.272,10.96c6.558,0,11.9-4.85,12.272-10.96 c8.233,2.135,18.34,5.449,22.772,9.65c-0.124-0.336-0.25-0.668-0.379-0.994c-2.726-5.158-14.082-9.191-23.065-11.656 c-0.352,6.11-5.402,10.96-11.601,10.96c-6.198,0-11.249-4.85-11.6-10.96c-8.983,2.465-20.34,6.498-23.066,11.656 c-0.081,0.289-0.162,0.582-0.243,0.874C41.976,113.671,51.96,110.398,60.114,108.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E53D0C"
    },
    d: "M57.37,106.269c1.138,7.28,7.418,12.856,15.017,12.856c7.599,0,13.879-5.576,15.017-12.856 c-1.161-0.352-2.307-0.68-3.416-0.984c-0.352,6.11-5.402,10.96-11.601,10.96c-6.198,0-11.249-4.85-11.6-10.96 C59.677,105.589,58.531,105.917,57.37,106.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M75.804,90.657c0,0-0.5-2.226-3.417-2.226c-2.667,0-3.417,2.226-3.417,2.226H75.804z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.f92b49b07c92a86a0d6f99f572af8e3f.svg";
export { ForwardRef as ReactComponent };